import { useMemo } from 'react';

import { RetailerDocumentType } from '@common/models';

import { useRetailerSettings } from './useRetailerSettings';

/**
 * retailer documents are elements from the retailerSettings API results, identified by "documentType"
 * @param documentType the document type to match
 * @param isInstalled whether the current product is an installed product or "product only", defaults to true
 */
const INSTALL_SUFFIX = /\[Install]$/i;
const PO_SUFFIX = /\[Product Only]$/i;

const useRetailerDocument = (documentType: RetailerDocumentType, isInstalled = true): string | undefined => {
    const { retailerSettings } = useRetailerSettings();
    return useMemo<string | undefined>(() => {
        const doc = retailerSettings?.documents?.find(
            (document) =>
                document.type === documentType ||
                !!(document.type.match(documentType) && document.type.match(isInstalled ? INSTALL_SUFFIX : PO_SUFFIX))
        );
        return doc?.url ?? undefined;
    }, [isInstalled, retailerSettings, documentType]);
};

export default useRetailerDocument;
